import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { DataService } from '../../shared/services/data.service';
import { DocumentlibraryConstantsService } from './documentlibrary-constants.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentlibraryService {

  constructor(private dataService: DataService, private baseService: BaseService) { }

  uploadDocument(model, callbackMethod) {
    return this.dataService.post(DocumentlibraryConstantsService.DLGetURL.uploadDocument, model).subscribe(
      response => callbackMethod(response)
    );
  }

  RenameDocument(model, callbackMethod) {
    return this.dataService.post(DocumentlibraryConstantsService.DLGetURL.RenameDocument, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getLibraryDetails(model, callbackMethod) {
    return this.dataService.post(DocumentlibraryConstantsService.DLGetURL.getLibraryDetails, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getFileTypeDetails(model, callbackMethod) {
    return this.dataService.post(DocumentlibraryConstantsService.DLGetURL.getFileTypeDetails, model).subscribe(
      response => callbackMethod(response)
    );
  }
  deleteDocument(model, callbackMethod) {
    return this.dataService.post(DocumentlibraryConstantsService.DLGetURL.deleteDocument, model).subscribe(
      response => callbackMethod(response)
    );
  }

  revertDocument(model, callbackMethod) {
    return this.dataService.post(DocumentlibraryConstantsService.DLGetURL.revertDocument, model).subscribe(
      response => callbackMethod(response)
    );
  }
  
  downloadZIP(model, callbackMethod) {
    return this.dataService.postHttpResponse(DocumentlibraryConstantsService.DLGetURL.downloadZIP, model).subscribe(
      response => callbackMethod(response)
    );
  }

}
